import { isServer as c } from "lit";
const a = (t, e, r) => function(s, n) {
  const o = `#${n}`;
  Object.defineProperty(s, n, {
    get() {
      return this[o];
    },
    set(u) {
      e.includes(u) ? this[o] = u : (console.error(
        `<${t}> Invalid value "${u}" provided for property "${n}".`,
        `Must be one of: ${e.join(" | ")}.`,
        `Falling back to default value: "${r}"`
      ), this[o] = r);
    },
    configurable: !0
  });
}, d = (t) => function(r, i) {
  const s = `#${i}`;
  Object.defineProperty(r, i, {
    get() {
      return this[s];
    },
    set(n) {
      (n == null || typeof n == "string" && n.trim() === "") && console.error(`<${t}> Missing required attribute "${i}"`), this[s] = n;
    },
    configurable: !0
  });
};
function f(t, e) {
  customElements.get(t) ? console.warn(`PIE Web Component: "${t}" has already been defined. Please ensure the component is only being defined once in your application.`) : customElements.define(t, e);
}
function m(t) {
  return new CustomEvent(t.type, {
    detail: {
      sourceEvent: t
    },
    bubbles: t.bubbles,
    cancelable: t.cancelable
  });
}
function b(t, e, r) {
  e.startsWith("pie-") || console.warn("A custom event name should start with `pie-`");
  const i = new CustomEvent(e, {
    bubbles: !0,
    composed: !0,
    detail: r
  });
  t.dispatchEvent(i);
}
const h = (t) => {
  class e extends t {
    /**
     * A getter to determine whether the text direction is right-to-left (RTL).
     * If the `dir` property is present on the component, it will be used to determine the text direction.
     * If running on the client-side (not SSR) and the `dir` property is not present, the text direction will be inferred
     * from the document's root element. This inference is not available during SSR.
     * In all other cases, it will return `false`, indicating a left-to-right (LTR) text direction.
     *
     * @returns {boolean} - Returns `true` if the text direction is RTL, otherwise `false`.
     */
    get isRTL() {
      return this.dir ? this.dir === "rtl" : !c && !this.dir ? document.documentElement.getAttribute("dir") === "rtl" : !1;
    }
  }
  return e;
}, p = (t) => {
  class e extends t {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...i) {
      super(...i), this._internals = this.attachInternals();
    }
    get form() {
      return this._internals.form;
    }
  }
  return e.formAssociated = !0, e;
};
export {
  p as FormControlMixin,
  h as RtlMixin,
  f as defineCustomElement,
  b as dispatchCustomEvent,
  d as requiredProperty,
  a as validPropertyValues,
  m as wrapNativeEvent
};
